import React from 'react';
import PropTypes from 'prop-types';
import segmentProps from '../SegmentCard/propTypes';
import SegmentCard from '../SegmentCard/index';
import './styles.scss';
import { noop } from '../propTypes';
import ContentCard from '../ContentCard';
import LoadingComponent from '../LoadingComponent';
import VisibilitySensor from 'react-visibility-sensor';

function SegmentList({
    segments,
    onSegmentSelect,
    loading,
    activeSegment,
    onLastItem,
}) {
    const renderSegments = () => {
        return (
            segments &&
            segments.map(
                (
                    {
                        id,
                        name,
                        litterCount,
                        distance,
                        date,
                        duration,
                        location,
                        avatar,
                        zoomLevel,
                    },
                    index,
                ) => {
                    const isActive = activeSegment == id ? true : false;
                    return (
                        <VisibilitySensor
                            partialVisibility={true}
                            key={`segment-card-sensor-${id}`}
                        >
                            {({ isVisible }) => {
                                if (isVisible && index == segments.length - 1) {
                                    onLastItem();
                                }

                                return (
                                    <SegmentCard
                                        key={`segment-card-${id}`}
                                        name={name}
                                        startDate={date}
                                        isActive={isActive}
                                        litterCount={litterCount}
                                        distance={distance}
                                        duration={duration}
                                        segmentData={location}
                                        avatar={avatar}
                                        onClick={() => onSegmentSelect(id)}
                                        zoomLevel={zoomLevel}
                                    />
                                );
                            }}
                        </VisibilitySensor>
                    );
                },
            )
        );
    };

    const loader = (
        <div className="segmentsLoader">
            <LoadingComponent isLoading={loading} />
        </div>
    );

    const mainContent =
        segments && segments.length ? (
            loading ? (
                loader
            ) : (
                <div className="SegmentScrollListing mt-4 custom-scroll">
                    <div className="row">
                        <div className="col">{renderSegments()}</div>
                    </div>
                </div>
            )
        ) : (
            <div className="empty-segments">
                <span className="info">No Data Available</span>
            </div>
        );

    return (
        <ContentCard
            heading={'Segments'}
            subHeading={''}
            showDropDown={false}
            content={mainContent}
            cardSize={7}
        />
    );
}

SegmentList.propTypes = {
    segments: PropTypes.arrayOf(
        PropTypes.shape({
            ...segmentProps,
        }),
    ),
    onSegmentSelect: PropTypes.func,
    onLastItem: PropTypes.func,
    loading: PropTypes.bool,
    zoomLevel: PropTypes.number,
    activeSegment: PropTypes.number,
};

SegmentList.defaultTypes = {
    segments: [],
    onSegmentSelect: noop,
    onLastItem: noop,
    loading: false,
    zoomLevel: 13.0,
    activeSegment: null,
};

export default SegmentList;
